module.exports = __webpack_public_path__ + "img/topic.47ad2cec.svg";